<template>
    <div class="inspec-component">
       <!-- 质检信息 -->
      <div class="main-container-form">
        <section class="head-title clearfix">
          <div class="titleForm-container">质检信息</div>
          <div class="add" v-if="canEdit" @click="add('qualityInspection')">
            <img src="../../../assets/images/qualityTracing/nav_add.png" alt="">
            <span>添加</span>
          </div>
        </section>
        <el-form :id="'qualtity'+index" v-for="(item,index) in qualityInspections"  :key="item.guid"  :model="item" :rules="rules" ref="qualityInspections" label-width="100px">
          <span v-if="canEdit" @click="del('qualityInspection',index)" class="delete">删除</span>
          <!-- <el-form-item label="质检报告" prop="images">
            <el-upload
              style="width:700px;"
              :action="uploadURl"
              :file-list="fileList"
              list-type="picture-card"
              :with-credentials="true"
              :before-upload="beforeUpload"
              :on-success="handleSuccess"
              :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
            <h4 class="upload-tip">最多上传四张jpg/png图片，且不超过500kb</h4>
            <el-dialog :visible.sync="dialogVisible">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item> -->

          <el-form-item label="检测编号" prop="reportNumber">
            <el-select v-model="item.inspectionReport" placeholder="请选择" size="medium" style="width:100%;" @change="changeReportNumber($event,index)">
              <el-option v-for="item in testList" :key="item.id" :label="item.reportNumber" :value="item.reportNumber">
              </el-option>
            </el-select>
          </el-form-item>
          <!--  @change="changeQUalityCheck($event,index)" -->
          <el-form-item label="质检机构" prop="inspectionOrganizationName">
            <el-select v-model="item.inspectionOrganizationName" disabled placeholder="请选择" size="medium" style="width:100%;">
              <el-option v-for="list in organizationKeyValue" :key="list.id" :label="list.value" :value="list.key">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="检测时间" class="time" prop="inspectionDate">
            <el-date-picker
              v-model="item.inspectionDate"
              disabled
              type="datetime"
              style="width: 100%;"
              placeholder="选择日期时间"
              :clearable="false"
              default-time="12:00:00">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="item.phone" :disabled="true" size="medium" style="width:100%;" placeholder="请输入联系电话" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num20">
            </el-input>
          </el-form-item>
          <el-form-item label="机构地址" prop="detail">
            <el-input v-model="item.address" :disabled="true" size="medium" style="width:100%;" type="text" :maxlength="num30" placeholder="详细地址不得少于2个字符" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;"></el-input>
          </el-form-item>
          <el-form-item label="质检报告" prop="images">
            <div class="upload-img-list">
              <div class="upload-img" v-for="img in initImg(qualityInspections[index].images).defaultImg" :key="img.img">
                <img :src="img.url" alt="" />
              </div>
            </div>
          </el-form-item>
          <!-- <upload-component :disabled="true" :uploadList="initImg(qualityInspections[index].images)" :key="item.guid" @getImg="getImg(index,$event)"></upload-component> -->
        </el-form>
      </div>
    </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import imgUpload from "../../../service/base-url";
// import UploadComponent from "../qualityTracing/UploadComponent";
export default {
  name: "InspectComponent",
  // components: { UploadComponent },
  props: {
    qualityInspections: {
      type: Array,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      num20: 20,
      num11: 11,
      num30: 30,
      uploadList: {
        defaultImg: [
          {
            name: "food.jpeg",
            url: require("../../../assets/images/qualityTracing/sample_jianyanbaogao2.png")
          }
        ],
        fileList: []
      },
      dialogImageUrl: "",
      dialogVisible: false,
      defaultImg: [
        {
          name: "food.jpeg",
          url: require("../../../assets/images/qualityTracing/sample_jianyanbaogao2.png")
        }
      ],
      fileList: [],
      uploadURl: imgUpload.imgUpload, // 文件上传地址
      pickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      organizationKeyValue: [], //机构下拉框列表
      // 质检信息
      rules: {
        name: [
          {
            required: true,
            message: "请先选择质检机构",
            trigger: "change"
          }
        ],
        inspectionDate: [
          {
            required: true,
            trigger: "blur"
          }
        ]
      },
      testList: []
    };
  },
  // watch: {
  //   qualityInspections(value) {
  //     console.log(value);
  //   }
  // },
  mounted() {
    this.getOrganizationData();
    this.getInspectionDropDownList();
  },
  methods: {
    ...mapActions(modules.qualityCheck, [
      "getInspectionOrganizationKeyValue", //获取获取质检机构下拉框列表
      "getEditQualityCheckManage"
    ]),
    ...mapActions(modules.area, {
      getProvinces: "getProvinces",
      getArea: "getArea"
    }),
    // 获取检测编号列表
    getInspectionDropDownList() {
      this.$api.getInspectionDropDownList().then(res => {
        console.log(res);
        this.testList = res.data;
      });
    },
    initImg(arr) {
      let uploadList = {
        defaultImg: []
      };
      if (arr.length != 0) {
        arr.forEach((element, index) => {
          uploadList.defaultImg.push({
            name: index,
            url: this.uploadURl + "/" + element,
            img: element
          });
        });
      } else {
        uploadList.defaultImg.push({
          name: "food.jpeg",
          url: require("../../../assets/images/qualityTracing/sample_jianyanbaogao2.png")
        });
      }
      return uploadList;
    },
    getImg(index, e) {
      this.qualityInspections[index].images = e;
      let obj = {
        inspectionOrganizationId: this.qualityInspections[index]
          .inspectionOrganizationId,
        inspectionDate: this.qualityInspections[index].inspectionDate,
        phone: this.qualityInspections[index].phone,
        address: this.qualityInspections[index].address,
        // fullAddress: data.fullAddress + data.address,
        images: this.qualityInspections[index].images,
        inspectionOrganizationName: this.qualityInspections[index]
          .inspectionOrganizationName
      };
      this.$emit("getInspect", obj, index);
    },
    judgeImgLength(fileList) {
      console.log(fileList);
      if (this.qualityInspections.images.length == 0) {
        this.fileList = this.defaultImg;
      } else {
        if (fileList.length != this.qualityInspections.images.length) {
          this.fileList = fileList.splice(1, 1);
        } else {
          this.fileList = fileList;
        }
      }
    },
    // 图片上传之前
    beforeUpload() {
      if (this.qualityInspections.images.length >= 4) {
        this.$Alert.info({
          content: "最多上传四张图片",
          duration: 3000,
          status: "error"
        });
        return false;
      }
    },
    // 文件上传成功
    handleSuccess(res, file, fileList) {
      this.qualityInspections.images.push(res.name);
      this.judgeImgLength(fileList);
    },
    // 文件移除
    handleRemove(file, fileList) {
      if (file.id) {
        this.index = this.qualityInspections.images.indexOf(file.id);
      } else if (file.response) {
        this.index = this.qualityInspections.images.indexOf(file.response.name);
      } else {
        let urlSlashCount = file.url.split("/").length; // 统计有3斜杠
        let str = file.url.split("/")[urlSlashCount - 1].toLowerCase(); //获取数组最后一个
        this.index = this.qualityInspections.images.indexOf(str);
      }
      if (this.index != -1) {
        this.qualityInspections.images.splice(this.index, 1);
        this.judgeImgLength(fileList);
      }
    },
    changeReportNumber(e, index) {
      console.log(e, index);
      let list = this.testList;
      list.map(item => {
        if (e === item.reportNumber) {
          this.qualityInspections[index].inspectionOrganizationName =
            item.organizationId;
          this.qualityInspections[index].phone = item.organizationPhone;
          this.qualityInspections[index].address = item.organizationAddress;
          this.qualityInspections[index].inspectionDate = item.inspectionTime;
          this.qualityInspections[index].inspectionReport = item.reportNumber;
          this.qualityInspections[index].inspectionReportId = item.id;
          this.qualityInspections[index].inspectionUser = item.inspector;
          this.qualityInspections[index].inspectionOrganizationId =
            item.organizationId;
          this.qualityInspections[index].inspectionOrganizationName =
            item.organizationName;
          let imgs = [];
          item.images.map(item => {
            imgs.push(item.name);
          });
          this.qualityInspections[index].images = imgs;
        }
      });
    },
    async changeQUalityCheck(e, index) {
      this.getEditQualityCheckManage(e).then(async data => {
        this.qualityInspections[index].inspectionOrganizationId = data.id;
        this.qualityInspections[index].phone = data.phone;
        let imgs = [];
        data.images.map(item => {
          imgs.push(item.name);
        });
        this.qualityInspections[index].images = imgs;
        this.qualityInspections[index].address =
          data.fullAddress + data.address;
        this.qualityInspections[index].inspectionOrganizationName = data.name;
        let obj = {
          inspectionOrganizationId: this.qualityInspections[index]
            .inspectionOrganizationId,
          inspectionDate: this.qualityInspections[index].inspectionDate,
          phone: this.qualityInspections[index].phone,
          address: this.qualityInspections[index].address,
          // fullAddress: data.fullAddress + data.address,
          images: this.qualityInspections[index].images,
          inspectionOrganizationName: this.qualityInspections[index]
            .inspectionOrganizationName
        };
        this.$emit("getInspect", obj, index);
      });
    },
    // 获取机构keyValue
    getOrganizationData() {
      this.getInspectionOrganizationKeyValue()
        .then(rsp => {
          this.organizationKeyValue = rsp;
        })
        .catch(err => {
          console.dir(err);
        });
    },
    // 添加流通商信息
    add(name) {
      console.log(this.qualityInspections);
      // this.qualityInspections.push(1);
      console.log(this.qualityInspections);
      this.$emit("addInspect");
    },
    // 删除 流通商信息
    del(name, index) {
      this.qualityInspections.splice(index, 1);
    }
  }
};
</script>

<style lang="stylus">
.isHide {
  display: none;
}
// 去除上传图片动画过度效果
.el-upload-list__item {
  transition: none !important;
}
.driver-component
  .time
    .el-input__inner
      height 44px;
      line-height 44px;
  textarea
    font-size:14px;
    font-family:MicrosoftYaHeiUI;
    font-weight:400;
    color:rgba(51,51,51,1);
    min-height:180px !important;
    width: 500px !important
  .two-row
    display flex;
    .el-form-item
      width:300px;
  .content-form-container
    background #f2f3f6
  .el-form-item 
    width 600px;
  .el-input--medium .el-input__inner
    line-height 44px;
    height:44px;
  .el-form
    .el-upload--picture-card
      float left 
      margin-right 10px;
  
</style>
<style lang="stylus" scoped>
  .upload-img-list
    display: flex;
    .upload-img
      width: 160px;
      height: 220px;
      position: relative;
      margin-right: 12px;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      img
        max-width: 100%;
        width: auto;
        height: auto;
        -webkit-transform: translate(-50%,-50%);
        transform: translate(-50%,-50%);
        position: absolute;
        left: 50%;
        top: 50%;
  .upload-tip
    position absolute
    top:150px;
    bottom:20px;
    height:30px;
    font-size:14px;
    font-family:MicrosoftYaHeiUI;
    font-weight:400;
    color:rgba(176,176,176,1);
  .el-form{
    border-top:1px solid #eee!important;
  }
  .main-container-form
    overflow:hidden;
    margin-bottom:10px;
    border:1px solid #e0e0e0;
    background #fff
  .el-form
    position relative
    padding: 28px 0 40px 150px
  .head-title
    line-height:48px;
    font-size:16px;
    background #f7f7f7;
    .titleForm-container
      float left;
      height:48px;
      line-height:48px;
      font-weight: initial;
    .add
      float right;
      margin-right:95px;
      color:#3389FF
      cursor:pointer;
      img 
        margin-right:7px;
        vertical-align: middle;
      span 
        vertical-align: middle;
  .delete
    position absolute;
    right: 85px;
    top:28px;
    width:80px;
    border-radius:4px;
    line-height:36px;
    text-align:center;
    color:#fefefe;
    cursor:pointer;
    background:#E23A0D;
    z-index:999;
  .save-cancel
    padding:20px 0 40px 0;
</style>
